import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { filter } from 'rxjs/operators';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NavComponent } from "./nav/nav.component";
import { LayoutModule } from "@angular/cdk/layout";
import { MainComponent } from "./layouts/main/main.component";
import { SingleComponent } from "./layouts/single/single.component";
import { DashboardModule } from "./dashboard/dashboard.module";
import { MaterialModule } from "./material.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ResultsModule } from "./results/results.module";
import { SettingsModule } from "./settings/settings.module";
import { UsersModule } from "./users/users.module";
import { ConfirmCancelDialogComponent } from "./confirm-cancel-dialog/confirm-cancel-dialog.component";
import { NotFoundComponent } from "./not-found/not-found.component";
import { ShortEmailPipe } from "./pipes/short-email.pipe";
import { ServiceWorkerModule, VersionReadyEvent } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { CorpClientsService } from "./corp-clients.service";
import { SwUpdate } from "@angular/service-worker";
import {
  faClipboardList,
  faChartArea,
  faUser,
  faUsers,
  faCog,
  faChartLine,
  faArrowAltCircleRight,
  faSpinner,
  faHome,
  faKey,
  faUserTimes,
  faUserPlus,
  faSyncAlt,
  faChartBar,
  faCaretLeft,
  faCaretRight,
  faVideo,
  faCopy,
  faFileAlt,
  faSave,
  faSync,
  faStop,
  faCaretUp,
  faEnvelopeOpen,
  faEye,
  faCommentDollar,
  faHeart,
  faThumbsUp,
  faGrinSquintTears,
  faSmile,
  faSurprise,
  faPlayCircle,
  faBullhorn,
  faAddressCard,
  faComment,
  faStar,
  faMedkit,
  faCamera,
  faEnvelopeOpenText,
  faStream,
  faInfoCircle,
  faQrcode,
  faCloudArrowDown,
  faPlus,
  faCloudArrowUp,
  faTrophy,
  faShareSquare,
  faCheckSquare,
  faShare,
  faClone,
  faRotateRight,
  faEnvelope,
  faUserTag,
  faShareAlt,  
  faIdCard,
  faScroll,
  faPhotoFilm,
  faBuilding
} from "@fortawesome/free-solid-svg-icons";
import {
  faFileAlt as farFileAlt,
  faCirclePlay as farCirclePlay,
  faCalendarCheck as farCalendarCheck,
  faHeart as farHeart,
} from "@fortawesome/free-regular-svg-icons";
import { ReplyCommentDialog } from "./ok-dialog/ReplyCommentDialog.component";
import { AppAnalyticsService } from "src/app-analytics.service";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

@NgModule({ declarations: [
        AppComponent,
        NavComponent,
        MainComponent,
        SingleComponent,
        ConfirmCancelDialogComponent,
        ReplyCommentDialog,
        NotFoundComponent,
        ShortEmailPipe,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        DashboardModule,
        MaterialModule,
        FontAwesomeModule,
        ResultsModule,
        SettingsModule,
        UsersModule,
        ServiceWorkerModule.register("ngsw-worker.js", {
            enabled: environment.production,
        })], providers: [CorpClientsService, AppAnalyticsService, provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class AppModule {
  constructor( public updates: SwUpdate, library: FaIconLibrary) {
    library.addIcons(
      faLinkedin,
      faClipboardList,      
      faCheckSquare,
      faChartArea,
      faUser,
      faUsers,
      faUserTag,
      faCog,
      faChartLine,
      faArrowAltCircleRight,
      faSpinner,
      faHome,
      faKey,
      faUserTimes,
      faUserPlus,
      faSyncAlt,
      faChartBar,
      faCaretLeft,
      faCaretRight,
      faEnvelopeOpen,
      faEye,
      faVideo,
      faCopy,
      faFileAlt,
      faSave,
      faSync,
      faStop,
      faCaretUp,
      faCommentDollar,
      faHeart,
      faThumbsUp,
      faGrinSquintTears,
      faSmile,
      faSurprise,
      faPlayCircle,
      faBullhorn,
      faAddressCard,
      faComment,
      farFileAlt,
      farCirclePlay,
      farCalendarCheck,
      farHeart,
      faStar,
      faMedkit,
      faCamera,
      faEnvelopeOpenText,
      faStream,
      faInfoCircle,
      faQrcode,
      faCloudArrowDown,
      faCloudArrowUp,
      faPlus,
      faTrophy,
      faShareSquare,
      faShare,
      faClone,
      faRotateRight,
      faEnvelope,
      faShareAlt,
      faIdCard,
      faScroll,
      faPhotoFilm,
      faBuilding
    );

    
    // https://v17.angular.io/guide/service-worker-communications#updating-to-the-latest-version
    updates.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(evt => {
          console.debug(`New version ready, reloading`,evt);
          document.location.reload();
      });

      updates.unrecoverable.subscribe(event => {
        // https://v17.angular.io/guide/service-worker-communications#handling-an-unrecoverable-state
        console.debug(event);  
        document.location.reload();
      });
    
  }

  updateApp() {
    document.location.reload();
    console.log("The app is updating right now");
  }
}
